import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { pathSatisfies } from "ramda";

import { isPresent } from "./presence";

const test = pathSatisfies(isPresent);

const usePollQuery = (query, { variables, pollInterval, pollTimeout, testPath }) => {
  const { data, loading, error, stopPolling } = useQuery(query, { pollInterval, variables });
  const [timedOut, setTimedOut] = useState(false);
  const testPassed = test(testPath, data);

  useEffect(() => {
    if (testPassed) {
      stopPolling();
      return;
    }

    const timeout = setTimeout(() => {
      if (testPassed) {
        return;
      }
      setTimedOut(true);
      stopPolling();
    }, pollTimeout);

    return () => clearTimeout(timeout);
  }, [testPassed, stopPolling]);

  const dataAvailable = !loading && testPassed;

  return { data, loading, error, timedOut, dataAvailable };
};

export default usePollQuery;
